<template>
  <div class="div">
    <img :src="logo" alt=""/>
  </div>
</template>

<script>
export default {
  data(){
    return {
      logo:require("@/assets/images/logo.png")
    }
  },
  methods:{
  },
  mounted(){
  }
};
</script>

<style scoped>
div img{
  width: inherit;
  height: inherit;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/header/header.vue